module.exports = __webpack_public_path__ + "img/chilun@3x.e9046961.png";